<template>
	<div class="ReInputSearchDropType">
		<base-input
			:disabled="disabled"
			:name="name"
			:placeholder="placeholder"
			addon-left-icon="tim-icons icon-zoom-split"
			v-model="value.inputText"
			@keyup="getSearch"
			autocomplete="off"
		>
		</base-input>
		<ul v-if="bInSearch" class="my-0 mb-1 w-100 dropdown-menu show">
			<li class="searchProg dropdown-item cursor-pointer">Поиск данных <i class="tim-icons icon-refresh-02 rotate"></i></li>
		</ul>
		<ul v-if="!bInSearch" :class="[{'show':masDataOpt.length > 0},]" v-click-outside="hide" class="my-0 mb-1 w-100 dropdown-menu">
			<li v-for="opt in masDataOpt" :key="opt.value"
				@click="ClickOnOpt(opt)"
				style="white-space: normal;"
				class="dropdown-item cursor-pointer" v-html="PrintOptText(opt)"></li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'ReInputSearchDropType',
		components: {

		},
		props: {
			placeholder: String,
			name: String,
			objApiMethod: {
				type: Object,
				default() {	return {}; }
			},
			strApiMethodKey:{
				type: String,
				required: true
			},
			strApiMethod:{
				type: String,
				default: 'GET_CAT_METRO_DIST_GK_DEV'
			},
			MinTxtLen: {
				type: Number,
				default:2,
			},
			value: {
				type: Object,
				default() {	return {
					inputText: '',
					selectedVal:'',
					selectedType:'',
				}; }
			},
			strType:{
				type: String,
				default: 'METRO_DIST_GK_DEV',
			},
			disabled:{
				type: Boolean,
				default: false,
			}
		},
		data () {
			return {
				ver: 1,
				inputText: '',
				bInSearch: false,
				iApiCallCnt: 0,
				masDataOpt: [],
			}
		},
		computed: {

		},
		methods: {
			getSearch(ev){
				if ((this.value.inputText.length > this.MinTxtLen) && !this.$GVO.isEmpty(this.objApiMethod)){
					const masFilterKeys = Object.keys(this.objApiMethod.flt);
					if(masFilterKeys.length>0){
						this.objApiMethod.flt[this.strApiMethodKey] = this.value.inputText;
						this.bInSearch = true;
						this.iApiCallCnt++;
						let iCurApiCallCnt = this.iApiCallCnt;
						this.$GVO.ApiCall(this.strApiMethod,this.objApiMethod)
							.then((objApi) => { 
								if(objApi.success === true){ //console.log(objApi);
									if ((objApi.total > 0 || objApi.data.length > 0) && this.value.inputText.length > this.MinTxtLen){
										if (iCurApiCallCnt == this.iApiCallCnt){
											this.masDataOpt = [];
											this.bInSearch = false;
											//console.log(this.strType);
											for (let i = 0; i < objApi.data.length; i++) {
												let strHTMLicon = '';
												switch (objApi.data[i].s_type) {
													case 'dmetro':
														strHTMLicon = '<i class="tim-ic ic-metro mr-2"></i>';
														break;
													case 'ddist':
														strHTMLicon = '<i class="tim-icons icon-square-pin mr-2"></i>';
														break;
													case 'ddev':
														strHTMLicon = '<i class="tim-ic ic-developer mr-2"></i>';
														break;
													case 'dgk':
														strHTMLicon = '<i class="tim-ic ic-gk-building mr-2"></i>';
														break;
													default:
														break;
												}
												this.masDataOpt.push({text:`${strHTMLicon}${objApi.data[i].name}`,value:objApi.data[i].id, type: objApi.data[i].s_type});
											}
											this.iApiCallCnt = 0;
											//console.log('getSearch',this.masDataOpt);
										}
									}else{
										if (iCurApiCallCnt == this.iApiCallCnt) {
											this.bInSearch = false;
											this.masDataOpt = [];
										}
									}
								}else{
									if (iCurApiCallCnt == this.iApiCallCnt) {
										this.bInSearch = false;
										this.masDataOpt = [];
									}
								}
							}).catch(errorObjApi => console.error(errorObjApi));
					}
				}else{
					this.masDataOpt = [];
					this.bInSearch = false;
					this.iApiCallCnt = 0;
					//eventEmitter.$emit('ObSearchDrop_cleared',true);
				}
			},
			ClickOnOpt(opt){
				//console.log(opt);
				this.value.inputText = opt.text.replace( /<i(.*?)i>/si, "" );
				this.value.selectedVal = opt.value;
				this.value.selectedType = opt.type;
				this.$emit('input', {inputText:opt.text.replace( /<i(.*?)i>/si, "" ),selectedVal:opt.value,selectedType:opt.type});
				this.$emit('change',{inputText:opt.text.replace( /<i(.*?)i>/si, "" ),selectedVal:opt.value,selectedType:opt.type});
				this.masDataOpt = [];
			},
			PrintOptText(opt){
				if (typeof opt.value != 'undefined'){
					if (typeof opt.text != 'undefined'){
						return '<span>'+opt.text+'</span>';
					}
				}
			},
			hide(){
				this.masDataOpt = [];
			}
		},
	}
</script>
<style scoped>
.ReInputSearchDropType >>> .dropdown-menu i {font-size: 1.2rem; top: 3px;}

</style>
